import { FC } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import TextField from '@app/components/input/TextField';

import ValidationMessage from '../ValidationMessage/ValidationMessage';
import messages from '../Address.messages';
import { AddressFormFields } from '../Address.constants';

export const AddressFields: FC<{ namespace: string }> = ({ namespace }) => {
  const { errors } = useFormContext();

  return (
    <>
      <Controller
        name={`${namespace}.${AddressFormFields.StreetLine1}`}
        defaultValue=""
        render={({ ref, ...props }) => (
          <TextField
            autoComplete="address-line1"
            maxLength={35}
            isValid={!errors[namespace]?.street?.[0]}
            formLabel={<FormattedMessage {...messages.addressLineOne} />}
            innerRef={ref}
            {...props}
          />
        )}
        rules={{
          required: {
            value: true,
            //  @ts-expect-error: TS only support string, not ReactElement (react-hook-form.com/api#register)
            message: (
              <ValidationMessage
                type="required"
                fieldNameKey="addressLineOne"
              />
            ),
          },
        }}
      />

      <Controller
        name={`${namespace}.${AddressFormFields.StreetLine2}`}
        defaultValue=""
        rules={{ setValueAs: (value) => value || null }}
        render={({ ref, ...props }) => (
          <TextField
            autoComplete="address-line2"
            maxLength={35}
            formLabel={
              <>
                <FormattedMessage {...messages.addressLineTwo} /> (
                <FormattedMessage {...messages.optional} />)
              </>
            }
            innerRef={ref}
            {...props}
          />
        )}
      />

      <Controller
        name={`${namespace}.${AddressFormFields.Postcode}`}
        defaultValue=""
        render={({ ref, ...props }) => (
          <TextField
            autoComplete="postal-code"
            maxLength={60}
            isValid={!errors[namespace]?.[AddressFormFields.Postcode]}
            formLabel={<FormattedMessage {...messages.postalCode} />}
            half
            innerRef={ref}
            {...props}
          />
        )}
        rules={{
          required: {
            value: true,
            //  @ts-expect-error: TS only support string, not ReactElement (react-hook-form.com/api#register)
            message: (
              <ValidationMessage type="required" fieldNameKey="postalCode" />
            ),
          },
        }}
      />

      <Controller
        name={`${namespace}.${AddressFormFields.City}`}
        defaultValue=""
        render={({ ref, ...props }) => (
          <TextField
            autoComplete="address-level2"
            maxLength={128}
            isValid={!errors[namespace]?.[AddressFormFields.City]}
            formLabel={<FormattedMessage {...messages.city} />}
            innerRef={ref}
            {...props}
          />
        )}
        rules={{
          required: {
            value: true,
            //  @ts-expect-error: TS only support string, not ReactElement (react-hook-form.com/api#register)
            message: <ValidationMessage type="required" fieldNameKey="city" />,
          },
        }}
      />
    </>
  );
};
